// Circle Cards Reveal Animation (ES Module)
// Uses global gsap, ScrollTrigger, and CustomEase from window object

document.addEventListener("DOMContentLoaded", () => {
     const container = document.querySelector('.circle-cards-container');
     if (!container) return;

     if (typeof gsap === 'undefined') {
          console.error('GSAP not loaded, circle cards animation will not work');
          return;
     }

     if (typeof CustomEase !== 'undefined') {
          gsap.registerPlugin(CustomEase);
          CustomEase.create("hop", "0.75, 0, 0.2, 1");
     } else {
          console.log('CustomEase not available, using fallback easing');
     }

     const introCards = document.querySelectorAll(".circle-cards-intro-cards .circle-cards-card");
     const introCardsCount = introCards.length;
     const radius = window.innerWidth < 1000 ? 150 : 220;

     introCards.forEach((card, i) => {
          const angle = (i / introCardsCount) * Math.PI * 2 - Math.PI / 2;

          let x = radius * Math.cos(angle);
          let y = radius * Math.sin(angle);

          const containerRect = container.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          const cardWidth = cardRect.width || 120;
          const cardHeight = cardRect.height || 165;

          const maxX = (containerRect.width - cardWidth) / 2 - 10;
          const minX = -maxX;
          x = Math.max(minX, Math.min(maxX, x));

          const maxY = (containerRect.height - cardHeight) / 2 - 10;
          const minY = -maxY;
          y = Math.max(minY, Math.min(maxY, y));

          gsap.set(card, {
               x: x,
               y: y,
               rotation: (angle * 180) / Math.PI + 90,
               transformPerspective: 800,
               transformOrigin: "center center",
               scale: 0,
          });
     });

     const outroCards = document.querySelectorAll(".circle-cards-outro-cards .circle-cards-card");

     const firstIntroCardAngle = (0 / introCardsCount) * Math.PI * 2 - Math.PI / 2;
     const firstIntroCardX = radius * Math.cos(firstIntroCardAngle);
     const firstIntroCardY = radius * Math.sin(firstIntroCardAngle);

     outroCards.forEach((card, index) => {
          gsap.set(card, {
               x: firstIntroCardX,
               y: firstIntroCardY,
               rotation: (firstIntroCardAngle * 180) / Math.PI + 90,
               rotationY: index === 0 ? 0 : 180,
               transformPerspective: 800,
               transformOrigin: "center center",
               zIndex: 5 - index,
               opacity: 0,
          });
     });

     const calculateCardPositions = () => {
          const viewportWidth = window.innerWidth;
          const cardRect = outroCards[0].getBoundingClientRect();
          const cardWidth = cardRect.width;
          const padding = viewportWidth < 1000 ? 16 : 32;
          const maxLeftPos = -(viewportWidth / 2) + padding + cardWidth / 2;
          const maxRightPos = viewportWidth / 2 - padding - cardWidth / 2;

          return [0, maxLeftPos, maxLeftPos / 2, maxRightPos / 2, maxRightPos];
     };

     const tl = gsap.timeline({
          scrollTrigger: {
               trigger: container,
               start: "top 80%",
               toggleActions: "play none none reverse"
          }
     });

     tl.to(introCards, {
          scale: 1,
          duration: 1,
          stagger: 0.1,
          ease: "hop",
          onComplete: () => {
               gsap.set(outroCards, { opacity: 1 });
               gsap.set(outroCards[0], { scale: 1, rotation: 0 });
               gsap.set(outroCards[1], { scale: 0.1, rotation: -90 });
               gsap.set(outroCards[2], { scale: 0.1, rotation: -45 });
               gsap.set(outroCards[3], { scale: 0.1, rotation: 90 });
               gsap.set(outroCards[4], { scale: 0.1, rotation: 45 });
          },
     });

     tl.to(introCards, {
          scale: 0,
          duration: 1,
          stagger: 0.1,
          ease: "hop",
     })
          .to(
               outroCards,
               {
                    y: window.innerWidth < 1000 ? 0 : -125,
                    duration: 1.5,
                    ease: "hop",
               },
               "-=0.25"
          )
          .to(
               outroCards[0],
               {
                    rotationY: 180,
                    duration: 1.5,
                    ease: "hop",
               },
               "<"
          )
          .to(
               outroCards,
               {
                    x: (index) => calculateCardPositions()[index],
                    scale: 1,
                    rotation: 0,
                    duration: 1.5,
                    ease: "hop",
               },
               "<"
          );

     const heroFooterTl = gsap.timeline({
          scrollTrigger: {
               trigger: container,
               start: "top 80%",
               toggleActions: "play none none reverse"
          }
     });

     heroFooterTl
          .to(".circle-cards-hero-footer h2", {
               scale: 1,
               duration: 1.25,
               ease: "hop",
          }, "+=2.25");

     const updateCardPositions = () => {
          const positions = calculateCardPositions();

          outroCards.forEach((card, index) => {
               gsap.set(card, { x: positions[index] });
          });
     };

     window.addEventListener("resize", updateCardPositions);
     
     console.log('✅ Circle Cards Reveal initialized');
});

export default {};
